export default __webpack_public_path__ + "static/media/globe-and-mail.ea811223.png";